export default __webpack_public_path__ + "static/media/cross.b5a6f05d.svg";